import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';

import { Select, Form } from 'ui/components';
import { SkeletonText, SkeletonsForm, Skeletons } from 'ui/components/skeleton';
import { ItemStock } from 'services/action';

const initialState = {
  items: [
    {
      item_id: null,
      item: null,
      fraction: null,
      fraction_id: null,
      stock: null,
      quantity: null,
    },
  ],
};


export const FormItems = ({ data, isLoading,  onItemChange }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const StateWarehouse = useSelector((state) => state?.Auth?.warehouse);
  const [{ items }, setState] = React.useState(initialState);

  const $onLoadItemStock = async (i, e) => {
    const req = await Dispatch(
      ItemStock.$showByItemAndWarehouse(e?.id, StateWarehouse?.id)
    );

    let stock = "0";
    if (req !== undefined || req !== 'undefined') {
      stock = req?.stock_available_fracted;
    }

    let newItems = [...items];
    newItems[i]['stock'] = stock;

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $handleItemsChange = async (i, e, name) => {
    let newItems = [...items];

    if (e?.target?.name) {
      newItems[i][e.target.name] = e.target.valueNumber;
    } else {
      newItems[i][`${name}_id`] = e?.id;
      newItems[i][name] = e;

      if (name === 'item') {
        // get item stock with item_id and warehouse_id
        $onLoadItemStock(i, e);
      }
    }

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          item_id: null,
          item: null,
          fraction_id: null,
          fraction: null,
          stock: null,
          quantity: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    newItems.splice(i, 1);

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  React.useEffect(() => {
    const state = {
      items,
    };

    onItemChange(state);
  }, [items]);

  React.useEffect(() => {
    if (!data) return;

    let b = [];
    if (data) {
      data?.items?.forEach((i) => {
        b.push({
          item_id: i?.item?.id,
          item: i?.item,
          fraction_id: i?.fraction?.id,
          fraction: i?.fraction,
          stock: i?.stock,
          quantity: i?.quantity
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [data]);

  React.useEffect(() => {
    if (data) return;

    setState({items: [
      {
        item_id: null,
        item: null,
        fraction_id: null,
        fraction: null,
        stock: null,
        quantity: null,
      },
    ],});
  }, [])

  return (
    <div>
      <div
        className="fw-semibold py-2 border-bottom mb-3"
        style={{ fontSize: 13 }}
      >
        {isLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Daftar Item'
        )}
      </div>

      {isLoading ? (
        <>
          <div className="row padding-20 rounded-2 border">
            <div className="col-md-4">
              <SkeletonsForm count={1} />
            </div>
            <div className="col-md-4">
              <SkeletonsForm count={1} />
            </div>
            <div className="col-md-4">
              <SkeletonsForm count={1} />
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <Skeletons height={30} />
          </div>
        </>
      ) : (
        <>
          {items?.map((e, i) => (
            <div
              className={cn(
                'px-3 py-3 mb-3 border rounded position-relative',
                StateForm?.errors?.items ? 'border-danger' : ''
              )}
              key={i}
            >
              <div className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center">
                {items?.length > 1 && (
                  <div className="p-1">
                    <Fi.FiX
                      color="red"
                      size={20}
                      onClick={() => $removeField(i)}
                      className="cursor-pointer"
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className='col-md-5'>
                  <div className="mb-3">
                    <Select.Remote
                      required
                      label="Pilih Item"
                      placeholder=""
                      url="/wms/item"
                      value={e?.item?.id}
                      initialValue={e?.item?.id}
                      params={{ order_by: 'id', is_active: 'active' }}
                      row={(d) => {
                        return {
                          value: d.id,
                          label: d.alias_name,
                        };
                      }}
                      keys={e?.item?.id}
                      onSelected={(e) => $handleItemsChange(i, e, 'item')}
                      errors={
                        StateForm?.errors[`items.${i}.item_id`]
                      }
                    />
                  </div>
                </div>
                <div className="col-md-2 ps-0">
                  <div className="mb-3">
                    <Select.Remote
                      label="Pilih Fraction"
                      required
                      placeholder=""
                      url={`/wms/item/${e?.item?.id}/fractions`}
                      initialValue={e?.fraction_id}
                      name="fraction_id"
                      row={(d) => {
                        return {
                          value: d?.id,
                          label: d?.name,
                        };
                      }}
                      onSelected={(e) => $handleItemsChange(i, e, 'fraction')}
                      keys={e?.item_id}
                      disabled={!e?.item_id}
                      errors={
                        StateForm?.errors[`items.${i}.fraction_id`]
                      }
                    />
                  </div>
                </div>
                <div className="col-md-2 ps-0 ">
                  <Form.Input
                    autoComplete="off"
                    label="Stok"
                    name="current_stock"
                    type="text"
                    value={e?.stock}
                    disabled
                  />
                </div>
                <div className='col-md-3'>
                  <Form.Input
                    required
                    autoComplete="off"
                    label="Jumlah"
                    name="quantity"
                    type="number"
                    value={e?.quantity}
                    onChange={(e) => $handleItemsChange(i, e)}
                    error={
                      StateForm?.errors?.quantity ||
                      StateForm?.errors[`items.${i}.quantity`]
                    }
                  />
                </div>
              </div>
              {StateForm?.errors?.items && (
                <div className="invalid-feedback d-block ">
                  {StateForm?.errors?.items}
                </div>
              )}
            </div>
          ))}
          <button
            type="button"
            className="btn btn-primary rounded mb-3"
            style={{ minHeight: 36, minWidth: '100%' }}
            onClick={() => $addMoreFields()}
          >
            <Fi.FiPlus className="me-2" /> Tambah Item
          </button>
        </>
      )}
    </div>
  );
};
